import { E } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { EAppAccountType } from '../../constants';

@Component({
  selector: 'lum-setting-push-invoice-to-oms',
  templateUrl: './setting-push-invoice-to-oms.component.html',
  styleUrls: ['./setting-push-invoice-to-oms.component.scss'],
})
export class SettingPushInvoiceToOmsComponent implements OnInit {
  @Input() formData :UntypedFormGroup;

  constructor(private formBuilder :UntypedFormBuilder) {}

  ngOnInit() :void {
    this.initForm();
  }

  private initForm() {
    const localFormGroup :UntypedFormGroup = this.formBuilder.group({
      invoice_push_to_oms: [false],
      invoice_push_to_oms_automatically: [false],
      invoice_push_to_oms_timing: [null],
      invoice_push_to_oms_account_id: [null],
      invoice_push_to_oms_store_id: [null],
    });
    Object.keys(localFormGroup.controls).forEach((key) => {
      this.formData.addControl(key, localFormGroup.controls[key]);
    });
  }

  // since we support push to shipstation for now
  get supportedAppAccountType() :string {
    return EAppAccountType.SHIPSTATION;
  }

  get shouldPushInvoiceToOms() :boolean {
    return this.formData.value.invoice_push_to_oms;
  }

  get shouldPushInvoiceToOmsAutomatically() :boolean {
    return this.formData.value.invoice_push_to_oms_automatically;
  }

  get selectedAppIntegrationAccountId() :number {
    return parseInt(this.formData.value.invoice_push_to_oms_account_id);
  }
}
